import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Check if #cards element exists
const cardsContainer = document.querySelector("#cards");

if (cardsContainer) {

// Create a matchMedia context for screens 993px and above
    let mm = gsap.matchMedia();

    mm.add("(min-width: 993px)", () => {
        const cards = document.querySelectorAll("#cards .card");
        const card_height = cards[0].offsetHeight + 15;
        const totalCards = cards.length; // This will be 4

        // // console.log(card_height);

        const endPosition = `bottom -=${card_height * 4}px`;

        const timeline_one = gsap.timeline({
            scrollTrigger: {
                ease:"none",
                trigger: "#cards",
                start: "top+=20px top",
                // end: "bottom -=300%",
                end: endPosition, // Use calculated end position
                pinSpacing: true,
                pin: true,
                scrub: true,
                // markers: {
                //     startColor: "blue",
                //     endColor: "orange",
                //     fontSize: "14px",
                //     name: "Step2-Card2"
                // }
            }
        });

        // Step 1: Move cards 2, 3, 4 up by 1 card height
        timeline_one.add(
            gsap
                .timeline()
                .to("#cards .card:nth-child(2)", { y: -card_height + "px" }, 0)
                .to("#cards .card:nth-child(3)", { y: -card_height + "px" }, 0)
                .to("#cards .card:nth-child(4)", { y: -card_height + "px" }, 0)
                .to("#cards .card:nth-child(1)", {
                    opacity: 1,
                    zIndex: 0
                }, 0)
        );

        // Step 2: Move cards 3, 4 up by 2 card heights total
        timeline_one.add(
            gsap
                .timeline()
                .to("#cards .card:nth-child(3)", { y: -(card_height * 2) + "px" }, 0)
                .to("#cards .card:nth-child(4)", { y: -(card_height * 2) + "px" }, 0)
                .to("#cards .card:nth-child(1)", {
                    opacity: 1,
                    zIndex: 0
                }, 0)
                .to("#cards .card:nth-child(2)", {
                    opacity: 1,
                    zIndex: 0
                }, 0)
        );

        // Step 3: Move card 4 up by 3 card heights total
        timeline_one.add(
            gsap
                .timeline()
                .to("#cards .card:nth-child(4)", { y: -(card_height * 3 - 20) + "px" }, 0)
                .to("#cards .card:nth-child(1)", {
                    opacity: 1,
                    zIndex: 0
                }, 0)
                .to("#cards .card:nth-child(2)", {
                    opacity: 1,
                    zIndex: 0
                }, 0)
                .to("#cards .card:nth-child(3)", {
                    opacity: 1,
                    zIndex: 0
                }, 0)
        );








        // ScrollTrigger for Step 1 - Card 1 (Using same approach as working Card 2)
        ScrollTrigger.create({
            trigger: "#cards .card:nth-child(1)",
            start: "top bottom",
            end: "bottom top",
            onEnter: () => {
                // console.log("Step 1 - onEnter - Card 1");
            },
            onLeaveBack: () => {
                // console.log("Step 1 - onLeaveBack - Card 1");
            },
            onLeave: () => {
                // console.log("Card 1 - onLeave FIRING!");
                const card1Element = document.querySelector(".card-1");
                if (card1Element) {
                    card1Element.classList.add("block-out");
                    // console.log("Card 1 classes:", card1Element.className);
                }
            },
            onEnterBack: () => {
                // console.log("Card 1 - onEnterBack FIRING!");
                const card1Element = document.querySelector(".card-1");
                if (card1Element) {
                    card1Element.classList.remove("block-out");
                    // console.log("Card 1 classes:", card1Element.className);
                }
            },
            // markers: {
            //     startColor: "green",
            //     endColor: "red",
            //     fontSize: "14px",
            //     name: "Card1-Direct"
            // }
        });

        // ScrollTrigger for Step 2 - Card 2
        ScrollTrigger.create({
            trigger: "#cards .card:nth-child(1)",
            start: `top+=${card_height * 2 + 30}px bottom`, // More precise positioning
            end: `top+=${card_height * 3 + 30}px`,

            // start: "top+=${card_height * 1 + 30}px bottom",
            // end: "bottom top",
            onEnter: () => {
                // console.log("Step 2 - onEnter - Card 2");
            },

            onLeave: () => {
                // console.log("Step 2 - onLeave - Card 2");
                document.querySelector(".card-2").classList.add("block-out");
                gsap.to(".card-2", {
                    ease: "none",
                });
            },
            onEnterBack: () => {
                // console.log("Step 2 - onEnterBack - Card 2");
                document.querySelector(".card-2").classList.remove("block-out");
                gsap.to(".card-2", {
                    ease: "none",
                });
            },

            onLeaveBack: () => {
                // console.log("Step 2 - onLeaveBack - Card 2");
            },
            // markers: {
            //     startColor: "blue",
            //     endColor: "orange",
            //     fontSize: "14px",
            //     name: "Step2-Card2"
            // }
        });

        // ScrollTrigger for Step 3 - Card 3 (Using same approach as working Card 2)
        ScrollTrigger.create({
            trigger: "#cards .card:nth-child(1)",
            start: `top+=${card_height * 4 + 20}px bottom`, // More precise positioning
            end: `top+=${card_height * 5 + 20}px`,
            onEnter: () => {
                // console.log("Step 3 - onEnter - Card 3");
            },
            onLeave: () => {
                // console.log("Card 3 - onLeave FIRING!");
                const card3Element = document.querySelector(".card-3");
                if (card3Element) {
                    card3Element.classList.add("block-out");
                    // console.log("Card 3 classes:", card3Element.className);
                }
            },
            onEnterBack: () => {
                // console.log("Card 3 - onEnterBack FIRING!");
                const card3Element = document.querySelector(".card-3");
                if (card3Element) {
                    card3Element.classList.remove("block-out");
                    // console.log("Card 3 classes:", card3Element.className);
                }
            },
            // markers: {
            //     startColor: "purple",
            //     endColor: "yellow",
            //     fontSize: "14px",
            //     name: "Card3-Direct"
            // }
        });

        // ScrollTrigger for Card 4 (Using same approach as other cards)
        // ScrollTrigger.create({
        //     trigger: "#cards .card:nth-child(4)",
        //     start: "top bottom-=100px",
        //     end: "bottom top+=100px",
        //     onLeave: () => {
        // //         console.log("Card 4 - onLeave FIRING!");
        //         const card4Element = document.querySelector(".card-4");
        //         if (card4Element) {
        //             card4Element.classList.add("block-out");
        // //             console.log("Card 4 classes:", card4Element.className);
        //         }
        //     },
        //     onEnterBack: () => {
        // //         console.log("Card 4 - onEnterBack FIRING!");
        //         const card4Element = document.querySelector(".card-4");
        //         if (card4Element) {
        //             card4Element.classList.remove("block-out");
        // //             console.log("Card 4 classes:", card4Element.className);
        //         }
        //     },
        //     // markers: {
        //     //     startColor: "orange",
        //     //     endColor: "pink",
        //     //     fontSize: "14px",
        //     //     name: "Card4-Direct"
        //     // }
        // });

    });
} else {
    // console.log("#cards element not found");
}